import React from 'react';
import { FieldDisplayProps } from '../../types';

export const DateFieldDisplay: React.FC<FieldDisplayProps> = ({
  value,
  onStartEditing,
  isReadOnly,
}) => {
  const handleClick = () => {
    if (!isReadOnly) {
      onStartEditing();
    }
  };

  if (!value) {
    return (
      <div
        className="pill custom-field-pill editable empty-placeholder"
        onClick={handleClick}
      />
    );
  }

  // Format date for display
  let displayValue = value;
  try {
    const date = new Date(value);
    if (!isNaN(date.getTime())) {
      displayValue = date.toLocaleDateString();
    }
  } catch {
    // Use raw value if parsing fails
  }

  return (
    <div
      className="pill custom-field-pill editable"
      onDoubleClick={handleClick}
      onClick={handleClick}
    >
      {displayValue}
    </div>
  );
};

export default DateFieldDisplay;
